<span *ngIf="value !== ''">{{value}}</span>
<input *ngIf="!value && value === ''" [size]="size" [id]="id" type="text" [required]="required" />
